import PropTypes from 'prop-types';

import { Button, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const ignoredProps = ['isActive', 'isLeftAlign'];

const StyledContainer = styled(Paper, {
  shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(({ theme, isLeftAlign }) => ({
  display: 'flex',
  gap: '1rem',
  justifyContent: isLeftAlign ? 'flex-start' : 'space-between',
  borderRadius: '1rem',
  padding: '1rem',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(({ theme, isActive, isLeftAlign }) => ({
  borderRadius: '1.4rem',
  height: '3rem',
  fontSize: '1.2rem',
  textTransform: 'uppercase',
  borderColor: theme.palette.custom.lightGrey,
  backgroundColor: theme.palette.custom.lightGrey,
  [theme.breakpoints.up('lg')]: {
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '45%',
  },
  ...(isLeftAlign && {
    width: 'auto !important',
  }),
  ...(isActive && {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  }),
}));

const RadioGroup = (props) => {
  const { options, currentValue, setCurrentValue, isLeftAlign } = props;
  return (
    <StyledContainer elevation={0} isLeftAlign={isLeftAlign}>
      {options.map(({ value, label }) => {
        const isActive = value === currentValue;
        return (
          <StyledButton
            key={value}
            variant="contained"
            color={isActive ? 'success' : 'inherit'}
            onClick={() => setCurrentValue(value)}
            isActive={isActive}
            disableElevation
            isLeftAlign={isLeftAlign}
          >
            {label}
          </StyledButton>
        );
      })}
    </StyledContainer>
  );
};

RadioGroup.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
  currentValue: PropTypes.string.isRequired,
  setCurrentValue: PropTypes.func.isRequired,
  isLeftAlign: PropTypes.bool,
};

export default RadioGroup;
